/* Naht & Leinen – Produktfamilien (Team B3): eigene Variantenauswahl (steuert die Craft-Auswahl), „Alle Designs“,
   Varianten-Karten, Sprung zum Kaufbereich, „Bewertung schreiben“. Versandbalken/Preis übernimmt B1 (nl-pdp.js). */
(function () {
  'use strict';
  if (window.nlFamAktiv) return;
  window.nlFamAktiv = true;

  var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Craft-Pubsub: PUB_SUB_EVENTS ist ein globales const (nicht an window gebunden) */
  function ereignisse() {
    try { return typeof subscribe === 'function' ? PUB_SUB_EVENTS : null; } catch (e) { return null; }
  }

  function wurzel(el) {
    return el.closest('product-info') || el.closest('.product__info-wrapper') || document;
  }

  function varianten(auswahl) {
    var s = auswahl.querySelector('[data-nl-fam-varianten]');
    if (!s) return [];
    try { return JSON.parse(s.textContent); } catch (e) { return []; }
  }

  function gewaehlteWerte(auswahl) {
    var werte = [];
    auswahl.querySelectorAll('fieldset[data-nl-fam-index]').forEach(function (f) {
      var i = parseInt(f.getAttribute('data-nl-fam-index'), 10);
      var c = f.querySelector('input:checked');
      werte[i] = c ? c.value : null;
    });
    return werte;
  }

  function passendeVariante(liste, werte) {
    return liste.find(function (v) {
      return v.o.every(function (w, i) { return werte[i] == null || werte[i] === w; });
    });
  }

  /* Craft-Auswahl (variant-selects) setzen und deren Logik (Preis, Bild, URL, Knopf) auslösen */
  function setzeNativ(root, index, wert) {
    var vs = root.querySelector('variant-selects');
    if (!vs) return false;
    var gruppen = vs.querySelectorAll('.product-form__input');
    var g = gruppen[index];
    if (!g) return false;
    var sel = g.querySelector('select');
    if (sel) {
      if (sel.value === wert) return true;
      sel.value = wert;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    var radios = g.querySelectorAll('input[type="radio"]');
    for (var k = 0; k < radios.length; k++) {
      if (radios[k].value === wert) {
        if (!radios[k].checked) {
          radios[k].checked = true;
          radios[k].dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    }
    return false;
  }

  function verfuegbarkeit(auswahl) {
    var liste = varianten(auswahl);
    var werte = gewaehlteWerte(auswahl);
    auswahl.querySelectorAll('fieldset[data-nl-fam-index]').forEach(function (f) {
      var i = parseInt(f.getAttribute('data-nl-fam-index'), 10);
      f.querySelectorAll('input').forEach(function (inp) {
        var probe = werte.slice();
        probe[i] = inp.value;
        var v = passendeVariante(liste, probe);
        var label = f.querySelector('label[for="' + inp.id + '"]');
        if (label) label.classList.toggle('is-ausverkauft', !v || !v.a);
      });
    });
  }

  function zeigeWerte(auswahl) {
    auswahl.querySelectorAll('fieldset[data-nl-fam-index]').forEach(function (f) {
      var c = f.querySelector('input:checked');
      var ziel = f.querySelector('[data-nl-fam-gewaehlt]');
      if (c && ziel) ziel.textContent = c.value;
    });
  }

  function aktualisiereAbhaengige(root, v) {
    if (!v) return;
    /* Varianten-Karten (z. B. Pombag-Farben) unten auf der Seite markieren */
    document.querySelectorAll('[data-nl-fam-wert][data-nl-fam-option]').forEach(function (k) {
      var i = parseInt(k.getAttribute('data-nl-fam-option'), 10);
      var opts = v.options || v.o || [];
      if (opts[i] === k.getAttribute('data-nl-fam-wert')) k.setAttribute('aria-current', 'true');
      else k.removeAttribute('aria-current');
    });
  }

  function waehle(auswahl, index, wert) {
    var root = wurzel(auswahl);
    var f = auswahl.querySelector('fieldset[data-nl-fam-index="' + index + '"]');
    if (f) {
      f.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === wert; });
    }
    zeigeWerte(auswahl);
    verfuegbarkeit(auswahl);
    var liste = varianten(auswahl);
    var v = passendeVariante(liste, gewaehlteWerte(auswahl));
    aktualisiereAbhaengige(root, v);
    if (!setzeNativ(root, index, wert) && v) {
      /* Keine Craft-Auswahl vorhanden: Seite mit der Variante laden */
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.location.href = url.toString();
    }
  }

  function auswahlStart(auswahl) {
    if (auswahl.dataset.nlFamBereit) return;
    auswahl.dataset.nlFamBereit = '1';

    auswahl.addEventListener('change', function (e) {
      var inp = e.target;
      if (!inp.matches('.nl-fam-opt__input')) return;
      var f = inp.closest('fieldset[data-nl-fam-index]');
      waehle(auswahl, parseInt(f.getAttribute('data-nl-fam-index'), 10), inp.value);
    });

    /* „Alle 33 Designs“: zunächst nur eine Reihe (ohne JS sind alle sichtbar); die gewählte bleibt immer sichtbar */
    auswahl.querySelectorAll('[data-nl-fam-alle]').forEach(function (knopf) {
      var werte = knopf.closest('fieldset').querySelector('[data-nl-fam-werte]');
      function reihe() {
        var labels = Array.prototype.slice.call(werte.querySelectorAll('.nl-fam-swatch'));
        labels.forEach(function (l) { l.classList.remove('is-weg'); });
        if (!werte.classList.contains('is-zu') || !labels.length) return;
        var oben = labels[0].offsetTop;
        var proReihe = labels.filter(function (l) { return l.offsetTop === oben; }).length || labels.length;
        labels.forEach(function (l, i) { if (i >= proReihe) l.classList.add('is-weg'); });
        var gew = werte.querySelector('input:checked + .nl-fam-swatch');
        if (gew && gew.classList.contains('is-weg') && proReihe > 0) {
          gew.classList.remove('is-weg');
          labels[proReihe - 1].classList.add('is-weg');
        }
      }
      function setze(offen) {
        werte.classList.toggle('is-zu', !offen);
        knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
        knopf.textContent = offen ? knopf.getAttribute('data-text-auf') : knopf.getAttribute('data-text-zu');
        reihe();
      }
      setze(false);
      knopf.addEventListener('click', function () { setze(knopf.getAttribute('aria-expanded') !== 'true'); });
      werte.addEventListener('change', reihe);
      var t0 = null;
      window.addEventListener('resize', function () { clearTimeout(t0); t0 = setTimeout(reihe, 150); });
    });

    verfuegbarkeit(auswahl);

    /* Änderungen von außen (URL-Variante, Craft-Neuaufbau) übernehmen */
    var ev0 = ereignisse();
    if (ev0) {
      subscribe(ev0.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v || !v.options) return;
        auswahl.querySelectorAll('fieldset[data-nl-fam-index]').forEach(function (f) {
          var i = parseInt(f.getAttribute('data-nl-fam-index'), 10);
          f.querySelectorAll('input').forEach(function (inp) { inp.checked = inp.value === v.options[i]; });
        });
        zeigeWerte(auswahl);
        verfuegbarkeit(auswahl);
        aktualisiereAbhaengige(wurzel(auswahl), v);
      });
    }
  }

  function zumKauf(e) {
    var ziel = document.getElementById('nl-fam-kauf');
    if (!ziel) return;
    e.preventDefault();
    var info = ziel.closest('.product__info-wrapper') || ziel;
    info.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
    var erstes = info.querySelector('.nl-fam-opt__input:checked, .nl-fam-opt__input, button[name="add"]');
    if (erstes) window.setTimeout(function () { erstes.focus({ preventScroll: true }); }, ruhig ? 0 : 450);
  }

  function start() {
    document.querySelectorAll('[data-nl-fam-auswahl]').forEach(auswahlStart);
  }

  document.addEventListener('click', function (e) {
    /* Varianten-Karten weiter unten (z. B. Pombag-Farben): Wert oben wählen und hochspringen */
    var karte = e.target.closest('[data-nl-fam-wert][data-nl-fam-option]');
    if (karte) {
      var auswahl = document.querySelector('[data-nl-fam-auswahl]');
      if (auswahl) {
        e.preventDefault();
        waehle(auswahl, parseInt(karte.getAttribute('data-nl-fam-option'), 10), karte.getAttribute('data-nl-fam-wert'));
        zumKauf(e);
        return;
      }
    }
    if (e.target.closest('[data-nl-fam-zum-kauf]')) { zumKauf(e); return; }
    var bew = e.target.closest('[data-nl-fam-bewerten]');
    if (bew) {
      var aufklapp = document.querySelector('[data-nl-fam-alle-bewertungen]');
      var warZu = aufklapp && !aufklapp.open;
      if (aufklapp) aufklapp.open = true;
      var widget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-widget.jdgm-review-widget, .jdgm-rev-widg');
      if (!widget) return;
      e.preventDefault();
      widget.scrollIntoView({ behavior: ruhig ? 'auto' : 'smooth', block: 'start' });
      /* Judge.me-Formular öffnen, sobald das Widget sichtbar ist */
      window.setTimeout(function () {
        var schreiben = widget.querySelector('.jdgm-write-rev-link');
        var huelle = widget.querySelector('.jdgm-form-wrapper');
        var offen = huelle && huelle.offsetParent !== null;
        if (schreiben && !offen) schreiben.click();
      }, warZu ? 400 : 50);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
